import request from '@/utils/request'
// import qs from 'qs'
// import store from '@/store/index'
// import axios from 'axios'
// import {userInfoBaseURL,requestTimeout} from '@/config/net.config.js'

/**
 *  查询 部门列表
 * @param {*} data 
 * @returns 
 */
export function queryDeptList() {
  return request({
    url: '/api/addressBook/queryDeptList',
    head: 'application/json;charset=UTF-8',
    method: 'get',
  })
}
/**
 * 根据部门id 查询 用户
 * @returns id
 */
export function queryUserByDeptId(id) {
    return request({
      url: '/api/addressBook/queryUserByDeptId?deptId='+id,
      head: 'application/json;charset=UTF-8',
      method: 'get',
    })
  }